import { axiosClient } from "./axiosClient"

export const PRODUCT_COLLECTION_PATH = '/api/v1/product-collection'

export const addProductCollection = (body) => {
    return axiosClient.post(PRODUCT_COLLECTION_PATH, body)
}

export const updateProductCollection = (id, body) => {
    return axiosClient.put(`${PRODUCT_COLLECTION_PATH}/${id}`, body)
}

export const deleteProductCollection = (id) => {
    return axiosClient.delete(`${PRODUCT_COLLECTION_PATH}/${id}`)
}

export const getProductCollectionById = (id) => {
    return axiosClient.get(`${PRODUCT_COLLECTION_PATH}/${id}`)
}

export const getPageProductCollections = ({ page = 0, size = 20, search = '', lastId = '', id = "", code = '', name = '', type = "" }) => {
    return axiosClient.get(`${PRODUCT_COLLECTION_PATH}/page?page=${page}&size=${size}&search=${search}&lastId=${lastId}&id=${id}&code=${code}&name=${name}&type=${type}`)
}
